import React from 'react';
import { AiFillLinkedin } from "react-icons/ai";
import css from './icon.module.css'

export const linkedinIcon = ({ ariaLabel = 'LinkedIn' }) => {
  return (
    <AiFillLinkedin className={css.icon}/>
  );
};
